var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "root" } },
    [
      !_vm.$route.meta.public
        ? [
            _c(
              "v-app",
              { staticClass: "app", attrs: { id: "inspire" } },
              [
                _c("app-header", { ref: "header", staticClass: "app-toolbar" }),
                _c(
                  "v-main",
                  { staticClass: "page-wrapper" },
                  [_c("router-view")],
                  1
                ),
              ],
              1
            ),
          ]
        : [
            _c(
              "transition",
              [
                _c(
                  "keep-alive",
                  [
                    _c("div", [_vm._v("block")]),
                    _c("router-view", { key: _vm.$route.fullpath }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
      _c("notifications", {
        staticStyle: { bottom: "6vh" },
        attrs: { position: "bottom right", width: "50%", ignoreDuplicates: "" },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }